module.exports = __webpack_public_path__ + "static/heroimg-5c50f901e8c59e1c4f792b2e87cc4ecf.svg";